//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Chart from "chart.js";
import {insightService} from "@/insight-service";
import {mapMutations} from "vuex";

export default {
  name: "TimeSeries",
  props: {
    model: {
      type: Object,
      value: undefined,
    },

    global: {
      type: Boolean,
      value: false
    }
  },

  data: () => ({
    metrics: null,
    graph: {}
  }),

  computed: {
    url: function () {
      return [this.$refs.auditMetrics.$.nx.client._baseURL, "api/v1/aicore/search/models"].join('/')
    },

    modelName: function () {
      return this.model.properties['ai_model:name'];
    },

    dates: function () {
      let keys = Object.values(this.metrics)
          .flatMap(item => item)
          .map(item => item.key);
      let unique = new Set(keys);
      return [...unique].sort((a, b) => a - b)
          .map(item => insightService.shortenDate(new Date(item)));
    },

    filled: function () {
      return this.metrics.filled.map(item => ({y: item.doc_count, x: insightService.shortenDate(new Date(item.key))}))
    },

    corrected: function () {
      return this.metrics.corrected.map(item => ({
        y: item.doc_count,
        x: insightService.shortenDate(new Date(item.key))
      }))
    },

    total: function () {
      return this.metrics.total.map(item => ({y: item.doc_count, x: insightService.shortenDate(new Date(item.key))}))
    },

    backtrack: function () {
      return this.metrics.backtrack.map(item => ({
        y: -item.doc_count,
        x: insightService.shortenDate(new Date(item.key))
      }))
    },

    minValue: function () {
      return Math.min(...this.backtrack.map(item => item.y)) - 3;
    },

    maxValue: function () {
      return Math.max(...this.total.map(item => item.y)) + 3;
    }
  },

  mounted: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      this._fetch();
    })
  },

  watch: {
    metrics: function () {
      if (!this.metrics) {
        return;
      }

      if (Object.keys(this.graph).length !== 0) {
        this.graph.destroy();
      }

      this.graph = this._chart();
      this.setMetrics(this.metrics);
    }
  },

  methods: {
    ...mapMutations({
      setMetrics: "setMetrics"
    }),

    _fetch() {
      if (!this.model && !this.global) {
        return;
      }

      let requests = [
        this._request(this._options("AUTO_FILLED", 1)),
        this._request(this._options("AUTO_CORRECTED", 1)),
        this._request(this._options(["AUTO_FILLED", "AUTO_CORRECTED"], 1)),
        this._request(this._options(["AUTO_FILLED", "AUTO_CORRECTED"], -1))
      ];

      Promise.all(requests)
          .then(results => {
            this.metrics = {
              filled: results[0].aggregations.by.buckets,
              corrected: results[1].aggregations.by.buckets,
              total: results[2].aggregations.by.buckets,
              backtrack: results[3].aggregations.by.buckets
            };
          })
          .catch(err => console.error(err));
    },

    _request(options) {
      return this.$refs.auditMetrics.$.nx.request()
          .then(request => {
            return request.execute(options);
          });
    },

    _options(event, value) {
      const params = {};

      if (!this.global) {
        params.modelName = this.modelName;
      }

      if (!Array.isArray(event)) {
        params.eventIds = "\"" + event + "\"";
      }

      params.agg = true;
      params.value = value;
      params.from = "now-90d";
      params.to = "now";

      let url = this.url + "?" + this.encodeQueryData(params);
      return {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        url,
      };
    },

    encodeQueryData(data) {
      const ret = [];
      for (let d in data)
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      return ret.join('&');
    },

    _dataset(values, label, index, axis = 'Primary') {
      let gs = this._chartColor(index);
      return {
        yAxisID: axis,
        label: label,
        data: values,
        borderColor: gs,
        backgroundColor: index === 2 ? null : gs,
        pointBackgroundColor: 'white',
        borderWidth: 3,
        fill: index !== 2,
        pointRadius: 2
      }
    },

    _chartColor(index) {
      switch (index) {
        case 0:
          return "rgba(185,221,252,0.7)";
        case 1:
          return "rgba(126,194,250,0.7)";
        case 2:
          return "rgba(7,139,248,0.7)";

        default:
          return "rgba(132,150,165,0.7)";
      }
    },

    _chart() {
      return new Chart(this.$refs.tsChart, {
        type: 'line',
        data: {
          datasets: [
            this._dataset(this.filled, "auto filled", 0),
            this._dataset(this.corrected, "auto corrected", 1),
            this._dataset(this.total, "total", 2, 'Secondary'),
            this._dataset(this.backtrack, "backtrack", 3)
          ],
          labels: this.dates
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          hover: {
            mode: "index",
          },
          legend: {
            display: true,
            position: 'bottom'
          },
          scales: {
            xAxes: [
              {
                display: true,
                type: "category",
                labels: this.dates,
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                  drawBorder: false,
                }
              },
            ],
            yAxes: [
              {
                id: 'Primary',
                position: 'left',
                display: true,
                stacked: true,
                scaleLabel: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  min: this.minValue,
                  max: this.maxValue
                },
                gridLines: {
                  drawBorder: false,
                }
              },
              {
                id: 'Secondary',
                position: 'right',
                display: true,
                scaleLabel: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  min: this.minValue,
                  max: this.maxValue
                },
                gridLines: {
                  drawBorder: false,
                }
              },
            ],
          },
        },
      })
    }
  }
};
